import { Component } from 'react'
import { connect } from 'react-redux'

// Actions
import { actions as cmsActions } from 'modules/cms/actions'
import { actions as headerActions } from 'modules/header/actions'

// Components
import Article from 'components/articles/detail'

// Selectors
import { selectRequest } from 'modules/requests/selectors'

// Types
import { ApiRequest, CmsPage, Dispatch, InitialDataProps, State } from 'types'

type BlogPageProps = {
  match: {
    params: { articleSlug: string }
  }
  // mapStateToProps
  articleSlug: string
  article: CmsPage
  fetchArticleRequest: ApiRequest
  // mapDispatchToProps
  fetchArticleBySlug: (slug: string) => void
  toggleStickyHeader: (headerVisible: boolean) => void
}

class BlogPage extends Component<BlogPageProps> {
  state = {
    headerVisible: false,
  }

  static loadInitialData({
    location: {
      params: { articleSlug },
    },
  }: InitialDataProps<{ articleSlug: string }>) {
    return (dispatch: Dispatch) => dispatch(cmsActions.fetchArticleBySlug(articleSlug))
  }

  componentDidMount() {
    const { articleSlug, fetchArticleBySlug, fetchArticleRequest } = this.props
    window.addEventListener('scroll', this.handleScroll)
    if (!fetchArticleRequest.isDone) {
      fetchArticleBySlug(articleSlug)
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  UNSAFE_componentWillReceiveProps(nextProps: BlogPageProps) {
    const { articleSlug, fetchArticleBySlug } = this.props
    if (articleSlug !== nextProps.articleSlug) {
      fetchArticleBySlug(articleSlug)
    }
  }

  handleScroll = () => {
    const { toggleStickyHeader } = this.props
    const { headerVisible } = this.state
    const scrollValue = window.scrollY
    const trigger = document.getElementById('header').offsetHeight
    if (scrollValue >= trigger && !headerVisible) {
      this.setState({
        headerVisible: true,
      })
      toggleStickyHeader(true)
    } else if (scrollValue < 1 && headerVisible) {
      this.setState({
        headerVisible: false,
      })
      toggleStickyHeader(false)
    }
  }

  render() {
    const { article } = this.props
    return article ? <Article article={article} /> : null
  }
}

const mapStateToProps = (
  state: State,
  {
    match: {
      params: { articleSlug },
    },
  }: BlogPageProps,
) => {
  const { pageSummaries, pages } = state.entities
  const articleSummary = Object.keys(pageSummaries)
    .map(id => pageSummaries[id])
    .find(article => article.meta.slug === articleSlug)
  const article = Object.keys(pages)
    .map(id => pages[id])
    .find(a => a.meta.slug === articleSlug)
  return {
    articleSlug,
    article: article || articleSummary,
    fetchArticleRequest: selectRequest(state, 'FETCH_ARTICLE_BY_SLUG', articleSlug),
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    fetchArticleBySlug: (articleSlug: string) => dispatch(cmsActions.fetchArticleBySlug(articleSlug)),
    toggleStickyHeader: (headerVisible: boolean) => dispatch(headerActions.toggleStickyHeader(headerVisible)),
  }
}
export { BlogPage as Component }
export default connect(mapStateToProps, mapDispatchToProps)(BlogPage)
